var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "104.000000pt",
    height: "43.000000pt",
    viewBox: "0 0 104.000000 43.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,43.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470 308 c0 -33 -3 -39 -12 -30 -22 22 -86 14 -113 -13 -29 -28 -34 -88 -10 -122 19 -26 77 -40 110 -25 15 7 26 7 33 0 24 -24 32 6 32 118 0 107 -1 114 -20 114 -17 0 -20 -7 -20 -42z m-12 -60 c7 -7 12 -29 12 -50 0 -40 -19 -58 -61 -58 -50 0 -79 69 -43 104 18 19 75 21 92 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680 329 c0 -24 23 -21 28 4 2 10 -3 17 -12 17 -10 0 -16 -9 -16 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 315 c-17 -18 -19 -25 -9 -25 8 0 21 6 28 13 11 10 14 10 18 0 3 -7 14 -13 26 -13 20 0 20 0 -3 25 -13 14 -26 25 -30 25 -4 0 -17 -11 -30 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 200 c0 -83 1 -90 20 -90 18 0 20 7 20 75 l0 75 35 0 c24 0 35 5 35 15 0 12 -13 15 -55 15 l-55 0 0 -90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680 200 c0 -73 3 -90 15 -90 12 0 15 17 15 90 0 73 -3 90 -15 90 -12 0 -15 -17 -15 -90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750 170 c0 -100 3 -120 15 -120 11 0 15 11 15 40 0 37 2 40 19 30 44 -23 111 -4 130 37 18 40 13 73 -18 104 -33 33 -74 38 -109 13 -20 -14 -22 -14 -22 0 0 9 -7 16 -15 16 -12 0 -15 -20 -15 -120z m135 76 c21 -15 25 -67 5 -90 -17 -21 -69 -20 -92 1 -22 20 -23 61 -1 85 19 21 62 24 88 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 263 c-12 -12 -6 -33 9 -33 8 0 15 6 15 14 0 17 -14 28 -24 19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 263 c-12 -12 -6 -33 9 -33 8 0 15 6 15 14 0 17 -14 28 -24 19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 248 c2 -7 10 -13 17 -13 7 0 15 6 18 13 2 7 -5 12 -18 12 -13 0 -20 -5 -17 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 191 c0 -11 11 -32 24 -48 34 -39 98 -39 132 0 24 29 32 67 14 67 -6 0 -13 -8 -17 -17 -25 -70 -101 -70 -126 0 -9 23 -27 22 -27 -2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrip);
export default __webpack_public_path__ + "static/media/drip.98248bbe7bd203b177f58860b61a9ba3.svg";
export { ForwardRef as ReactComponent };